import React from 'react'
import SubLink from '../../Route/SubLink';
import {CompanyManagerData} from '../../Route/SubLinkJSON';

function Companymanage() {
  return (
    <>
      <SubLink sublinks={CompanyManagerData} />
    </>
  )
}
export default Companymanage
